

import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
components: {
XHeader,
XInput,
Group
},
data () {
return {
model:{m_token:this.$route.query.token},
company:"",
documentTypeid:"",
address:"",
}
},
created () {
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getIsCert',this.model,{emulateJSON:true}).then(function(res){
if(res.body.cert==3){
this.$router.push('/user/cert/cert1')
}else if(res.body.cert==1){
this.$router.push('/user/cert/cert2')
}
else if(res.body.cert==2){
this.$router.push('/user/cert/cert3')
}
},function(res){
console.log(res.status);
});


this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getCompanyCert',this.model,{emulateJSON:true}).then(function(res){
this.company = res.body.company
this.documentTypeid = res.body.documentTypeid
this.address = res.body.address
},function(res){
console.log(res.status);
});
},

methods: {
goBack(){

this.$router.push({
path : '/learn/tryout',
query : {}
})
}

}
}



// WEBPACK FOOTER //
// ./src/views/user/cert2.vue